import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import FontAwesome from 'react-fontawesome'
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import AuditoriaSubstituicaoStore from "../stores/AuditoriaSubstituicaoStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";

const FILTROS = ["DATA_INICIAL", "DATA_FINAL", "JUSTIFICATIVA", "AREA", "DIVISAO", "EMPRESA", "CENTRAL"];
const VALIDACOES = ["DATA_FINAL_1_MES"];

@inject("store")
@DataWrapper
@observer
export class AuditoriaSubstituicao extends Component {
    constructor(props) {
        super(props);
        this.controller = new AuditoriaSubstituicaoStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Auditoria substituições");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                controller={this.controller}
                                history={this.props.history}
                                location={this.props.location}
                                fields={FILTROS}
                                validations={VALIDACOES}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)}
                                onExportPdf={(filtro) => this.controller.onExportPdf(filtro)} />
                        { this.controller.dados && this.controller.dados.length > 0 && !this.controller.erro &&
                            <BootstrapTable ref='table' version='4' data={this.controller.dados} striped hover pagination search condensed searchPlaceholder="Pesquisar">
                                {
                                    COLUMNS.map(column =>
                                        <TableHeaderColumn columnTitle { ...column } >
                                            { column.label }
                                        </TableHeaderColumn>
                                    )
                                }
                            </BootstrapTable>
                        }
                        {this.controller.erro &&
                            <MensagemErro>
                                {this.controller.erro}
                            </MensagemErro>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}

const COLUMNS = [
    { key: "1", label: "Número solicitação", dataField: "id", width: "150", dataSort: true, isKey: true },
    { key: "2", label: "N1", dataField: "area", width: "200", dataSort: true },
    { key: "3", label: "N2", dataField: "central", width: "200", dataSort: true },
    { key: "4", label: "N3", dataField: "divisao", width: "200", dataSort: true },
    { key: "5", label: "N4", dataField: "departamento", width: "200", dataSort: true },
    { key: "6", label: "Unidade de negócio (BU)", dataField: "empresa", width: "200", dataSort: true },
    { key: "7", label: "Motivo", dataField: "motivo", width: "100", dataSort: true },
    { key: "8", label: "Justificativa", dataField: "justificativa", width: "200", dataSort: true },
    { key: "9", label: "Cargo", dataField: "cargo", width: "200", dataSort: true },
    { key: "10", label: "Gestor solicitante", dataField: "gestorSolicitante", width: "200", dataSort: true },
    { key: "11", label: "Local de trabalho", dataField: "localTrabalho", width: "200", dataSort: true },
    { key: "12", label: "Nome", dataField: "nome", width: "200", dataSort: true },
    { key: "13", label: "Dt. admissão", dataField: "dataAdmissao", width: "100", dataSort: true },
    { key: "14", label: "Dt. fim contrato", dataField: "dataFimContrato", width: "100", dataSort: true },
    { key: "15", label: "Qtd. dias solicitação", dataField: "quantidadeDiasSolicitacao", width: "100", dataSort: true },
    { key: "16", label: "Nome funcionário substituído", dataField: "nomeFuncionarioSubstituido", width: "200", dataSort: true },
    { key: "17", label: "Matrícula funcionário substituído", dataField: "matriculaFuncionarioSubstituido", width: "100", dataSort: true },
    { key: "18", label: "Afastamento funcionário substituído", dataField: "afastamentoFeriasFuncionarioSubstituido", width: "100", dataSort: true },
    { key: "19", label: "Início férias/afastamento funcionário substituído", dataField: "inicioAfastamentoFeriasFuncionarioSubstituido", width: "100", dataSort: true },
    { key: "20", label: "Fim férias/afastamento funcionário substituído", dataField: "fimAfastamentoFeriasFuncionarioSubstituido", width: "100", dataSort: true },
    { key: "21", label: "% férias/afastamento funcionário substituído", dataField: "percentualAfastamentoFeriasFuncionarioSubstituido", width: "100", dataSort: true }
];